import { useState, createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { removeLocalStorage } from "utils/localStorageUtils";

const AdminUserContext = createContext();

export const AdminUserContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [adminUserData, setUserData] = useState({});

  const handleSignOut = () => {
    removeLocalStorage("suhail_admin_id");
    removeLocalStorage("suhail_admin_refreshToken");
    removeLocalStorage("suhail_admin_phoneNumber");
    removeLocalStorage("suhail_admin_token");
    removeLocalStorage("adminTokenExpiration");
    navigate("/admin/login");
  };

  return (
    <AdminUserContext.Provider
      value={{
        adminUserData,
        setUserData,
        handleSignOut,
      }}
    >
      {children}
    </AdminUserContext.Provider>
  );
};

export const useAdminUserContext = () => {
  return useContext(AdminUserContext);
};
